<template>
  <div v-if="!loading">
    <h3>{{ this.exchangeId }} > {{ this.tag }}</h3>

    <!-- prompts -->
    <prompt-table v-if="prompts.length" :forceShow="true" :showFandom="true" :prompts="prompts"></prompt-table>
    <div v-else-if="notFound">Tag not found!</div>
  </div>
  <div v-else-if="loading" class="loading"></div>
</template>

<script>
import axios from "axios";
import { map } from "lodash-es";
import { mapGetters } from "vuex";
import PromptTable from "../components/promptTable";
import utils from '../components/utils'
import data from "../store/data";

export default {
  name: "groupTag",
  components: { PromptTable },
  computed: {
    ...mapGetters(["exchangeId", "promptmarks", "options"])
  },
  data() {
    return {
      tag: "",
      groupBy: "",
      loading: true,
      notFound: false,
      prompts: []
    };
  },
  async beforeMount() {
    await this.redirectExchangeId();

    let exchangeId = this.$route.params.exchangeId;
    this.groupBy = this.$route.params.groupBy;
    this.tag = this.$route.params.tag;

    if (!this.exchangeId) {
      this.$store.commit("setExchangeId", exchangeId);
    }
    this.getTagPrompts();
  },
  watch: {
    async $route(to) {
      if (!to.name === "groupTag") {
        return;
      }
      await this.redirectExchangeId();

      this.prompts = [];
      let exchangeId = this.$route.params.exchangeId;
      this.$store.commit("setExchangeId", exchangeId);
      this.groupBy = this.$route.params.groupBy;
      this.tag = this.$route.params.tag;
      this.getTagPrompts();
    }
  },
  methods: {
    ...utils,
    async getTagPrompts() {
      this.loading = true;
      if (!this.exchangeId) {
        return;
      }

      let requests;
      const escapedTag = encodeURIComponent(this.tag);
      const exchange = encodeURIComponent(this.exchangeId);
      if (!this.groupBy) {
        this.loading = false;
        return;
      }
      switch (this.groupBy.toLowerCase()) {
        default:
        case "freeform":
          requests = await data.getExchangeFreeformRequests(
            exchange,
            escapedTag
          );
          break;
        case "relationship":
          requests = await data.getExchangeRelationshipRequests(
            exchange,
            escapedTag
          );
          break;
        case "character":
          requests = await data.getExchangeCharacterRequests(
            exchange,
            escapedTag
          );
          break;
      }
      this.prompts = requests;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.bookmark {
  width: 100px;
}
</style>
